import { NgMapsCoreModule } from '@ng-maps/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppPipesModule } from '../app-pipes/app-pipes.module';
import { ClientCornerMapComponent } from '../../pages/client-corner/client-corner-map/client-corner-map.component';
import { ClientCornerMarkerPopupComponent } from '../../pages/client-corner/client-corner-map/client-corner-marker-popup/client-corner-marker-popup.component';
import { ClientCornerProjectInfoComponent } from '../../pages/client-corner/client-corner-map/client-corner-marker-popup/client-corner-project-info/client-corner-project-info.component';
import { ClientPendingDetailComponent } from '../../pages/client-corner/client-project-detail/client-pending-detail/client-pending-detail.component';
import { ClientCornerHomePageComponent } from '../../pages/client-corner/client-corner-home-page/client-corner-home-page.component';
import { ClientCornerHomePageInpressWorkersComponent } from '../../pages/client-corner/client-corner-home-page/client-corner-home-page-inpress-workers/client-corner-home-page-inpress-workers.component';
import { ClientCornerHomePageCompanySelector } from '../../pages/client-corner/client-corner-home-page/client-corner-home-page-company-selector/client-corner-home-page-company-selector.component';
import { ClientCornerHomePageColleagueListComponent } from '../../pages/client-corner/client-corner-home-page/client-corner-home-page-colleague-list/client-corner-home-page-colleague-list.component';
import { ClientCornerHomePageCompletedSubProjectsComponent } from '../../pages/client-corner/client-corner-home-page/client-corner-home-page-completed-subprojects/client-corner-home-page-completed-subprojects.component';
import { ClientCornerHomePageCompletedSubProjectItemComponent } from '../../pages/client-corner/client-corner-home-page/client-corner-home-page-completed-subprojects/client-corner-home-page-completed-subproject-item/client-corner-home-page-completed-subproject-item.component';
import { ClientCornerCompletedOverviewComponent } from '../../pages/immo-ip/overview/client-completed/client-corner-completed-overview.component';
import { ClientProjectDetailComponent } from '../../pages/client-corner/client-project-detail/client-project-detail.component';
import { ClientAdjustmentDetailComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-detail.component';
import { NgMapsGoogleModule } from '@ng-maps/google';

@NgModule({
  imports: [
    CommonModule,
    MatPaginatorModule,
    SharedModule,
    AppPipesModule,
    NgMapsCoreModule,
    NgMapsGoogleModule,
  ],
  exports: [
    ClientCornerMapComponent,
    ClientCornerMarkerPopupComponent,
    ClientCornerProjectInfoComponent,
    ClientPendingDetailComponent,
    ClientCornerHomePageComponent,
    ClientCornerHomePageInpressWorkersComponent,
    ClientCornerHomePageCompanySelector,
    ClientCornerHomePageColleagueListComponent,
    ClientCornerHomePageCompletedSubProjectsComponent,
    ClientCornerHomePageCompletedSubProjectItemComponent,
    ClientCornerCompletedOverviewComponent,
    ClientProjectDetailComponent,
    ClientAdjustmentDetailComponent,
  ],
  declarations: [
    ClientCornerMapComponent,
    ClientCornerMarkerPopupComponent,
    ClientCornerProjectInfoComponent,
    ClientPendingDetailComponent,
    ClientCornerHomePageComponent,
    ClientCornerHomePageInpressWorkersComponent,
    ClientCornerHomePageCompanySelector,
    ClientCornerHomePageColleagueListComponent,
    ClientCornerHomePageCompletedSubProjectsComponent,
    ClientCornerHomePageCompletedSubProjectItemComponent,
    ClientCornerCompletedOverviewComponent,
    ClientProjectDetailComponent,
    ClientAdjustmentDetailComponent,
  ],
})
export class ClientCornerModule {}
